export default __webpack_public_path__ + "static/media/facebook.5ebde1b6.svg";